import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import CommonPopup from 'components/common/CommonPopup';
import TooltipCommon from 'components/common/TooltipCommon';
import TooltipButton from 'components/elements/buttons/TooltipButton';

import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';

import './FastlinkAction.css';


class FastlinkAction extends Component {
  static propTypes = {
    patchLink: PropTypes.func.isRequired,
    linkId: PropTypes.number.isRequired,
    isFastlink: PropTypes.bool,
    me: PropTypes.object,
  };

  static defaultProps = {
    isFastlink: null,
    me: null,
  };

  state = {
    firstChange: null,
    currentIsFastLink: null,
    popupOpen: false,
  };

  componentDidMount() {
    this.setState({
      currentIsFastLink: this.props.isFastlink,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { linkId, patchLink } = this.props;
    const { currentIsFastLink, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentIsFastLink !== this.state.currentIsFastLink
    ) {
      patchLink(linkId, { is_fastlink: currentIsFastLink });
    }

    if (prevProps.isFastlink !== this.props.isFastlink) {
      this.setState({ currentIsFastLink: this.props.isFastlink });
    }
  }

  onFastlinkChange = () => {
    this.setState({
      firstChange: true,
      currentIsFastLink: !this.state.currentIsFastLink,
      popupOpen: false,
    });
  };

  onPopupClose = () => {
    this.setState({ popupOpen: false });
  };

  renderTooltipContent = () => {
    const { isFastlink } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className="tooltip-content">
            {!isFastlink ?
              <div className="text-block">
                <div>
                  {t("Are you sure you want to re-direct all your customers to this link?")}
                </div>
                <div>
                  {t("You can only have one active Fast Link")}
                </div>
              </div>
              :
              <div className="text-block">
                <div>
                  {t("Are you sure you want to disable this Fast Link?")}
                </div>
              </div>
            }

            <div className="buttons-block">
              <TooltipButton onClick={this.onPopupClose}>
                {t("Cancel")}
              </TooltipButton>
              <TooltipButton
                positive={!isFastlink}
                negative={isFastlink}
                onClick={this.onFastlinkChange}
              >
                {isFastlink ?
                  t("Yes, disable Fast Link")
                  :
                  t("Yes, enable Fast Link")
                }
              </TooltipButton>
            </div>
          </div>
        )}
      </Translation>
    )
  };

  renderFastLinkActionButton = () => (
    <Translation>
      {(t) => (
        <div
          className={`link-fastlink-action__component
            ${this.state.currentIsFastLink ? ' active' : ''}`}
          onClick={() => this.setState({ popupOpen: true })}
          role="button"
          tabIndex={-1}
        >
          <div className="icon-container">
            <div className="icon" />
          </div>
          <div className="undertext">{t("Fast Link")}</div>
        </div>
     )}
    </Translation>
  );

  render() {
    const { linkId, me } = this.props;

    return (
      <Translation>
        {(t) => (
          <ProFeaturePlaceholder
            proLabel
            locked={
              me &&
              me.subscription &&
              !me.subscription.ff_fastlink
            }
            placeholderContent={
              me &&
              me.subscription &&
              me.subscription.billing_plan.title === 'Starter' ?
              <div>
                {t("Fast link is available on the")} <strong>PRO</strong> {t("plan")}.
              </div>
              :
              <div>
                {t("Fast link is available on request.")}
              </div>
            }
            className="fast-link-pro-placeholder"
            forFeatureFlag={
              me &&
              me.subscription &&
              me.subscription.billing_plan.title === 'Starter' ? false : true
            }
          >
            <TooltipCommon
              key={`fast-link-tooltip-key-${linkId}`}
              overlayClassName="fast-link-tooltip__component"
              header={t("Fast Link")}
              placement="bottom"
              trigger="click"
              visible={this.state.popupOpen}
              closeIcon
              onClose={this.onPopupClose}
              overlay={this.renderTooltipContent()}
            >
              <CommonPopup
                basic
                hideOnScroll
                wide="very"
                trigger={this.renderFastLinkActionButton()}
                triggerClassName="fast-link-tooltip__trigger"
              >
                <div>{t("Temporarily send all visitors to this link")}</div>
                <div>{t("you can only have one active Fast link")}</div>
              </CommonPopup>
            </TooltipCommon>
          </ProFeaturePlaceholder>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    patchLinkError: state.linksReducer.patchLinkError,
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLink,
  },
)(FastlinkAction);
